import type { StateCreator } from "zustand";
import type { ConfigState, GameFit, WidgetVariant } from "../types/types";

export interface ConfigSlice extends ConfigState {
  setLanguage: (language: string | null) => void;
  setCurrency: (currency: string | null) => void;
  setConfig: (language: string | null, currency: string | null) => void;
  setIsProvider: (isProvider: boolean) => void;
  setOverlayId: (overlayId: string | null) => void;
  setDockedOverlaySince: (dockedOverlaySince: string | null) => void;
  setVariant: (variant: WidgetVariant) => void;
  setGameFit: (gameFit: Record<number, GameFit> | null) => void;
}

export const createConfigSlice: StateCreator<ConfigSlice> = (set) => ({
  language: null,
  currency: null,
  isProvider: false,
  overlayId: null,
  dockedOverlaySince: null,
  variant: "on-site",
  gameFit: null,

  setLanguage: (language) => set({ language }),
  setCurrency: (currency) => set({ currency }),
  setConfig: (language, currency) => set({ language, currency }),
  setIsProvider: (isProvider) => set({ isProvider }),
  setOverlayId: (overlayId) => set({ overlayId }),
  setDockedOverlaySince: (dockedOverlaySince) => set({ dockedOverlaySince }),
  setVariant: (variant) => set({ variant }),
  setGameFit: (gameFit) => set({ gameFit }),
});
